// TODO enable eslint
/* eslint-disable react/destructuring-assignment */
import React from "react"
import { Box } from "@infotech/uikit-grid"
import omit from "lodash/omit"
import isObject from "lodash/isObject"
import { Button, PrimaryButton } from "@infotech/uikit-button"
import ModalWindow from "./ModalWindow"

function renderButton(Component, title, custom) {
  const props = isObject(custom)
    ? custom
    : {
        onClick: custom,
        children: `Применить`,
      }
  const FinalComponent = props.Component || Component
  const finalProps = props.Component ? omit(props, [`Component`]) : props
  return (
    <FinalComponent {...finalProps}>
      {finalProps.children ? finalProps.children : title}
    </FinalComponent>
  )
}

export default props => {
  const { onOk, onCancel, footer } = props

  const nextProps = omit(props, [`onOk`, `onCancel`, `footer`])

  return (
    <ModalWindow
      {...nextProps}
      footer={
        <Box
          flex
          style={{
            width: `100%`,
            justifyContent: `space-between`,
          }}
        >
          {onOk && (
            <Box flex align="center">
              {renderButton(PrimaryButton, `Применить`, onOk)}
            </Box>
          )}
          {onCancel && (
            <Box flex align="center">
              {renderButton(Button, `Отменить`, onCancel)}
            </Box>
          )}
          {footer}
        </Box>
      }
    />
  )
}
